
export function compareDates(date1, date2) {
  for(let i=0; i<date1.length; i++){
      if(date1[i]!==date2[i]){
          return +date1[i] > +date2[i];
      }
  }
  return  false
}
